/**
 * Calcula a luminância relativa de uma cor no formato HEX/RGB.
 * Retorna um valor entre 0 (preto) e 1 (branco).
 */
export const getLuminance = (color: string): number => {
  // Converte HEX para RGB (suporta formats: #RRGGBB, #RGB, rgb(r, g, b))
  let r: number, g: number, b: number;

  if (color.startsWith("#")) {
    // Remove '#' e expande formato curto (#RGB → #RRGGBB)
    const hex = color.slice(1).padEnd(6, color.slice(1));
    r = parseInt(hex.slice(0, 2), 16) / 255;
    g = parseInt(hex.slice(2, 4), 16) / 255;
    b = parseInt(hex.slice(4, 6), 16) / 255;
  } else if (color.startsWith("rgb")) {
    const match = color.match(/\d+/g);
    if (!match) return 0;
    [r, g, b] = match.map(Number).map((c) => c / 255);
  } else {
    return 0; // Fallback para preto
  }

  // Fórmula de luminância (WCAG 2.1)
  const [R, G, B] = [r, g, b].map((c) =>
    c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
  );
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
};

/**
 * Retorna 'white' ou 'black' com base no contraste com a cor de fundo.
 */
export const getContrastColor = (
  backgroundColor: string
): "white" | "black" => {
  const luminance = getLuminance(backgroundColor);
  // Limiar de contraste (WCAG recomenda > 0.5 para texto legível)
  return luminance > 0.5 ? "black" : "white";
};
